<template>
  <div>
    <div class="notification-icon">
      <div class="bicon">
        <b-icon pack="icomoon" size="is-medium" icon="glass" />
      </div>
      <span>{{ $t('compEcolabwareGlassForm.title') }}</span>
    </div>
    <b-notification :closable="false">
      <b-field
        :label="$t('compEcolabwareGlassForm.weight') + ' *'"
        :type="{ 'is-danger': errors.has('weight') }"
        :message="errors.first('weight')"
      >
        <b-input
          expanded
          type="number"
          v-validate="'required|numeric'"
          :placeholder="$t('compEcolabwareGlassForm.weight') + ' *'"
          name="weight"
          @input="$emit('input', buffer)"
          v-model="buffer.weight"
        />
        <p class="control">
          <span class="button is-static">g</span>
        </p>
      </b-field>
      <b-field
        :label="$t('compEcolabwareGlassForm.manufacturingArea') + ' *'"
        :type="{ 'is-danger': errors.has('manufacturingArea') }"
        :message="errors.first('manufacturingArea')"
      >
        <b-select
          expanded
          v-validate="'required'"
          :placeholder="$t('compEcolabwareGlassForm.manufacturingArea') + ' *'"
          name="manufacturingArea"
          @input="$emit('input', buffer)"
          v-model="buffer.manufacturingArea"
        >
          <option
            :value="area"
            v-for="(area, index) in MANUFACTURING_AREA"
            :key="index"
          >
            {{ $t('compEcolabwareGlassForm.' + area) }}
          </option>
        </b-select>
      </b-field>
      <b-field>
        <b-switch v-model="buffer.sterilized" @input="$emit('input', buffer)">
          {{ $t('compEcolabwareGlassForm.label-3') }}
        </b-switch>
      </b-field>
      <b-field>
        <b-switch
          v-model="buffer.decontamination"
          @input="$emit('input', buffer)"
        >
          {{ $t('compEcolabwareGlassForm.label-2') }}
        </b-switch>
      </b-field>
      <b-button
        style="margin-top: 43px"
        expanded
        icon-left="cogs"
        @click="activeModal = true"
      >
        {{ $t('compEcolabwareGlassForm.label-1') }}
      </b-button>
    </b-notification>
    <b-modal :active.sync="activeModal" has-modal-card>
      <div class="modal-card" style="width: 900px; height: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compEcolabwareGlassForm.title-1') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-notification :closable="false">
            <b-field>
              <b-switch v-model="cbuffer.prewash">
                {{ $t('compEcolabwareGlassForm.label-5') }}
              </b-switch>
            </b-field>
            <b-field v-if="cbuffer.prewash">
              <b-switch v-model="cbuffer.hotWaterUsed">
                {{ $t('compEcolabwareGlassForm.label-6') }}
              </b-switch>
            </b-field>
            <b-field
              v-if="cbuffer.prewash && cbuffer.hotWaterUsed"
              :label="$t('compEcolabwareGlassForm.label-7')"
            >
              <b-select
                expanded
                v-validate="'required'"
                v-model="cbuffer.heating"
              >
                <option
                  :value="type"
                  v-for="(type, index) in HEATING_TYPES"
                  :key="index"
                >
                  {{ $t('compEcolabwareGlassForm.' + type) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-if="cbuffer.prewash && cbuffer.hotWaterUsed"
              :label="$t('compEcolabwareGlassForm.label-8')"
            >
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.hotWaterVolume"
              />
              <p class="control">
                <span class="button is-static">L</span>
              </p>
            </b-field>
          </b-notification>
          <b-notification :closable="false">
            {{ $t('compEcolabwareGlassForm.info-1') }}
          </b-notification>
          <b-notification :closable="false">
            <b-field
              v-if="cbuffer.sterilized"
              :label="$t('compEcolabwareGlassForm.label-4')"
              :type="{ 'is-danger': errors.has('sterilized') }"
              :message="errors.first('sterilized')"
            >
              <b-input
                expanded
                v-validate="'required|numeric|min_value:1|max_value:100'"
                name="sterilized"
                type="number"
                v-model="cbuffer.filling"
              />
              <p class="control">
                <span class="button is-static">%</span>
              </p>
            </b-field>
            <b-field :label="$t('compEcolabwareGlassForm.label-13')">
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.nreuses"
              />
            </b-field>
            <b-field :label="$t('compEcolabwareGlassForm.label-9')">
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.ngloves"
              />
            </b-field>
            <b-field :label="$t('compEcolabwareGlassForm.label-10')">
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.nautoclaveCycleAWeek"
              />
            </b-field>
            <b-field :label="$t('compEcolabwareGlassForm.label-11')">
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.autoclaveWeight"
              />
              <p class="control">
                <span class="button is-static">Kg</span>
              </p>
            </b-field>
            <b-field :label="$t('compEcolabwareGlassForm.label-12')">
              <b-input
                expanded
                v-validate="'required|numeric'"
                type="number"
                v-model="cbuffer.autoclaveVolume"
              />
              <p class="control">
                <span class="button is-static">L</span>
              </p>
            </b-field>
          </b-notification>
          <nav class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <b-button
                class="level-item"
                @click="activeModal = false"
                icon-left="close"
              >
                {{ $t('cancel') }}
              </b-button>
              <b-button
                class="level-item"
                icon-left="save"
                type="is-primary"
                @click="applySettings()"
              >
                <span>{{ $t('apply') }}</span>
              </b-button>
            </div>
          </nav>
        </section>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { GlassLabWare } from '@/models/plastic/LabWare.js'

export default {
  name: 'GlassForm',
  props: {
    value: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      activeModal: false,
      NAMES: Object.keys(GlassLabWare.DEFAULT_CONFIGURATION),
      MANUFACTURING_AREA: GlassLabWare.MANUFACTURING_AREA,
      HEATING_TYPES: GlassLabWare.HEATING_TYPES,
      buffer: GlassLabWare.createFromObj(this.value),
      cbuffer: GlassLabWare.createFromObj(this.value)
    }
  },
  methods: {
    applySettings () {
      this.buffer = GlassLabWare.createFromObj(this.cbuffer)
      this.$emit('input', this.buffer)
      this.activeModal = false
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = GlassLabWare.createFromObj(this.value)
        this.cbuffer = GlassLabWare.createFromObj(this.value)
      },
      deep: true
    },
    activeModal: {
      handler () {
        if (!this.activeModal) {
          this.cbuffer = GlassLabWare.createFromObj(this.buffer)
        }
      }
    }
  }
}
</script>
